import { MeshStandardMaterial } from "three";

export const standardCleanedMaterial = new MeshStandardMaterial({
  color: "#16a34a",
  roughness: 0.55,
  metalness: 0.12,
});

export const standardFaultyMaterial = new MeshStandardMaterial({
  color: "#dc2626",
  roughness: 0.6,
  metalness: 0.08,
});

export const reachAndWashMaterial = new MeshStandardMaterial({
  color: "#0ea5e9",
  roughness: 0.5,
  metalness: 0.14,
});
